export class Question {

  public id: string;
  public position: number;
  public title: string;
  public description: string;
  public required: boolean;
  protected className: string;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id && obj.id.toString() || null;
    this.position = obj && obj.position || null;
    this.title = obj && obj.title || null;
    this.description = obj && obj.description || null;
    this.required = obj && obj.required || null;
    this.className = 'Question';
  }

  getClassName() {
    return this.className;  
  }

}